import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";
import connection from "../../connection";
import termosCondicoes from "../../assets/static/TERMOS_E_CONDICOES.pdf";
import politicaPrivacidade from "../../assets/static/PP_CORDILHEIRA.pdf";
import SweetAlert from "../SweetAlertWrapper";
import Contactos from "../../views/Pages/Contactos";

function Footer({...props}) {
  const {classes, fluid, white} = props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });
  var anchor =
    classes.a +
    cx({
      [" " + classes.whiteColor]: white
    });
  return (
    <footer className={classes.footer}>
      <div className={container}>
        <p className={classes.footerInner}>
          &copy; {1900 + new Date().getYear()}{" "}
          <a href="https://escutismo.pt" target={"_blank"} className={anchor}>
            {"Cordilheira"}
          </a>
          {" - v " + connection.getVersion() + " -"}
          <a href={termosCondicoes} target={"_blank"} className={anchor}> Termos e condições</a>
          {" -"}
          <a href={politicaPrivacidade} target={"_blank"} className={anchor}> Política de privacidade</a>
          {" -"}
          <a style={{cursor: "pointer"}} target={"_self"} className={anchor} onClick={() => {
            if (!window.App.state.user?.id)
              window.App.openModal(<SweetAlert
                showClose
                style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
                onConfirm={() => window.App.hideModal()}
                onCancel={() => window.App.hideModal()}
                confirmBtnText="Fechar"
                confirmBtnCssClass={
                  classes.button + " " + classes.primary + " " + classes.buttonConfirm
                }>
                <Contactos/>
              </SweetAlert>)
            else
              window.open("/contactos")
          }}> Contactos</a>
        </p>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);
